/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userTransferMessages.internal

import features.userTransferMessages.models.TransferMessagesModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class TransferMessagesRequest : NetworkRequest() {

    suspend fun getTransferMessages(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<TransferMessagesModel> {
        return safeNetworkCall {
            get(
                endpoint = TransferMessagesEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
